import { render, staticRenderFns } from "./CommonTitle.vue?vue&type=template&id=4d4f0aee&"
import script from "./CommonTitle.vue?vue&type=script&lang=js&"
export * from "./CommonTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d4f0aee')) {
      api.createRecord('4d4f0aee', component.options)
    } else {
      api.reload('4d4f0aee', component.options)
    }
    module.hot.accept("./CommonTitle.vue?vue&type=template&id=4d4f0aee&", function () {
      api.rerender('4d4f0aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/components/CommonTitle.vue"
export default component.exports